<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start"><ion-menu-button></ion-menu-button></ion-buttons>
    <ion-title>Bérlet és kompenzáció</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-segment [(ngModel)]="ful" style="max-width:520px;margin-bottom:12px">
    <ion-segment-button value="sajat"><ion-label>Saját beadványaim</ion-label></ion-segment-button>
    <ion-segment-button value="elbiralas" *ngIf="elbiralo"><ion-label>Elbírálás</ion-label></ion-segment-button>
  </ion-segment>

  <!-- ── SAJÁT: bérlet beadása ────────────────────────────────────────── -->
  <ng-container *ngIf="ful === 'sajat'">
    <ion-card>
      <ion-card-header>
        <ion-card-title>Havi bérlet beadása</ion-card-title>
        <ion-card-subtitle>
          Töltsd fel a bérlet számláját és add meg az összeget. A tétel elbírálásra kerül;
          jóváhagyás után számít bele a havi kompenzációba.
        </ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <div style="display:flex;gap:12px;flex-wrap:wrap;align-items:flex-end">
          <ion-input style="max-width:110px" fill="outline" label="Év" labelPlacement="stacked"
            type="number" [(ngModel)]="ev"></ion-input>
          <ion-select style="min-width:150px" fill="outline" label="Hónap" labelPlacement="stacked"
            interface="popover" [(ngModel)]="ho">
            <ion-select-option *ngFor="let m of [1,2,3,4,5,6,7,8,9,10,11,12]" [value]="m">{{m}}. hó</ion-select-option>
          </ion-select>
          <ion-input style="max-width:170px" fill="outline" label="Összeg (Ft)" labelPlacement="stacked"
            type="number" [(ngModel)]="uj.osszeg" placeholder="9500"></ion-input>
          <ion-input style="min-width:200px" fill="outline" label="Megnevezés" labelPlacement="stacked"
            [(ngModel)]="uj.megnevezes"></ion-input>
          <div>
            <div style="font-size:.78rem;color:#666;margin-bottom:4px">Számla (kötelező)</div>
            <input type="file" (change)="fajlValaszt($event)" accept="image/*,.pdf">
          </div>
          <ion-button color="success" [disabled]="fut" (click)="bead()">
            <ion-icon slot="start" name="cloud-upload"></ion-icon>Beadás
          </ion-button>
        </div>
        <ion-input style="margin-top:8px" fill="outline" label="Megjegyzés" labelPlacement="stacked"
          [(ngModel)]="uj.megjegyzes" placeholder="pl. bérletszám, útvonal"></ion-input>
      </ion-card-content>
    </ion-card>

    <ion-card>
      <ion-card-header><ion-card-title>Beadványaim</ion-card-title></ion-card-header>
      <ion-card-content>
        <ion-note color="medium" *ngIf="!sajatTetelek?.length">Még nincs beadott tételed.</ion-note>
        <ion-list *ngIf="sajatTetelek?.length">
          <ion-item *ngFor="let t of sajatTetelek">
            <ion-label>
              <b>{{t.ev}}. {{t.ho}}. hó – {{t.megnevezes || tipusNev(t.tipus)}}</b>
              <p>
                {{ t.osszeg | currency: 'HUF' : '' : '0.0' }} Ft
                <span *ngIf="t.tipus === 'ora'"> ({{t.ora}} óra × {{t.oradij | currency: 'HUF' : '' : '0.0'}} Ft)</span>
                <span *ngIf="t.indoklas"> · {{t.indoklas}}</span>
              </p>
            </ion-label>
            <ion-button slot="end" size="small" fill="outline" *ngIf="fajlUrl(t)" [href]="fajlUrl(t)" target="_blank">
              <ion-icon slot="start" name="document-outline"></ion-icon>Számla
            </ion-button>
            <ion-chip slot="end" [color]="statuszSzin(t.statusz)">{{statuszNev(t.statusz)}}</ion-chip>
            <ion-button slot="end" size="small" fill="clear" color="danger" *ngIf="t.statusz === 'beadva'"
              (click)="torol(t)">
              <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
            </ion-button>
          </ion-item>
        </ion-list>
      </ion-card-content>
    </ion-card>
  </ng-container>

  <!-- ── ELBÍRÁLÁS (bérügy) ───────────────────────────────────────────── -->
  <ng-container *ngIf="ful === 'elbiralas' && elbiralo">
    <ion-card>
      <ion-card-header>
        <ion-card-title>Beadványok elbírálása</ion-card-title>
        <ion-card-subtitle>A munkatársak havi bérlet- és kompenzáció-beadványai a kiválasztott hónapra.</ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <div style="display:flex;gap:12px;flex-wrap:wrap;align-items:flex-end;margin-bottom:10px">
          <ion-input style="max-width:110px" fill="outline" label="Év" labelPlacement="stacked"
            type="number" [(ngModel)]="ev" (ionChange)="betolt()"></ion-input>
          <ion-select style="min-width:150px" fill="outline" label="Hónap" labelPlacement="stacked"
            interface="popover" [(ngModel)]="ho" (ionChange)="betolt()">
            <ion-select-option *ngFor="let m of [1,2,3,4,5,6,7,8,9,10,11,12]" [value]="m">{{m}}. hó</ion-select-option>
          </ion-select>
          <ion-button size="small" color="secondary" (click)="betolt()">
            <ion-icon slot="start" name="refresh"></ion-icon>Frissítés
          </ion-button>
        </div>

        <ion-note color="medium" *ngIf="!osszesTetel?.length">Erre a hónapra nincs beadott tétel.</ion-note>
        <ion-list *ngIf="osszesTetel?.length">
          <ion-item *ngFor="let t of osszesTetel">
            <ion-label>
              <b>{{t.nev || t.allomany}}</b> – {{t.megnevezes || tipusNev(t.tipus)}}
              <p>
                {{ t.osszeg | currency: 'HUF' : '' : '0.0' }} Ft
                <span *ngIf="t.tipus === 'ora'"> ({{t.ora}} óra × {{t.oradij | currency: 'HUF' : '' : '0.0'}} Ft)</span>
                <span *ngIf="t.megjegyzes"> · {{t.megjegyzes}}</span>
                <span *ngIf="t.indoklas"> · indok: {{t.indoklas}}</span>
              </p>
            </ion-label>
            <ion-button slot="end" size="small" fill="outline" *ngIf="fajlUrl(t)" [href]="fajlUrl(t)" target="_blank">
              <ion-icon slot="start" name="document-outline"></ion-icon>Számla
            </ion-button>
            <ion-chip slot="end" [color]="statuszSzin(t.statusz)">{{statuszNev(t.statusz)}}</ion-chip>
            <ion-button slot="end" size="small" color="success" *ngIf="t.statusz !== 'jovahagyva'"
              (click)="dontes(t, 'jovahagy')">Jóváhagy</ion-button>
            <ion-button slot="end" size="small" color="danger" *ngIf="t.statusz !== 'elutasitva'"
              (click)="dontes(t, 'elutasit')">Elutasít</ion-button>
          </ion-item>
        </ion-list>
      </ion-card-content>
    </ion-card>
  </ng-container>
</ion-content>
